module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAJCAYAAAAVb42gAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOklEQVQI113LwQkAIAxD0Y+4Y8axHSdbepES7CXw+MX2IW4BlbjeDu6oy/YUgz90QkuaoiUVALYrfy76WxKCrdw4KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tri2.png
// module id = pDXc
// module chunks = 1